import { Base64 } from 'js-base64'
import { parseBinContent } from '@ps/utils/game'
import { AssetType } from '@ps/utils/config'
import _ from 'lodash'
import { getBlob } from '@ps/utils/base64-to-blob'
import router from '@ps/router'
import store from '@ps/store'
import assets from '@ps/bridge/qc/assets'
import i18n from '@ps/lang'
import { getFileName } from '@com/utils/file'
import { addDataURIPrefix } from '@com/utils/base64'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import { libDataPool } from '@ps/bridge/resource/pool/index'

export async function saveFiles(params) {
  const { binContent, url, base64 } = params
  const { suffix } = parseBinContent(binContent)
  const blob = getBlob(addDataURIPrefix(base64, suffix.replace('.', '')))
  const pid = router.currentRoute.query.id
  const res = await Promise.all([
    // 保存上传文件的bin文件
    store.dispatch('workspace/game/saveFile', {
      params: { pid, path: url },
      data: binContent,
    }),
    // 保存上传文件源文件
    store.dispatch('workspace/game/saveFile', {
      params: {
        pid,
        path: url.replace(/\.bin$/g, suffix),
      },
      data: blob,
    }),
  ])

  if (res.every((item) => item.code === 0)) {
    return true
  }
  throw new Error(i18n.t('workbench.utils.saveFileError'))
}

/**
 * updateImageComponent
 * @param data {{name: string, type: number, files: { name: string; data: string; }[]}}
 * @param record {boolean} 是否添加历史记录
 * @param resetImageAfterAdd {boolean} 添加完成后是否重置图片
 * @returns {Promise<boolean>}
 */
export async function updateImageComponent({
  data,
  resetImageAfterAdd = true,
  resetAnotherLayout = false,
  record = true,
  addImageToConfig = false,
  resourcePath,
  nodes,
  isUpdateImage = true,
  isSetLibData = false,
}) {
  const gameState = store.state.workspace.game
  const node = gameState.activeNode
  const binFile = data.files.find((item) => {
    return item.name.indexOf('.bin') > -1
  })
  const imageFile = data.files.find((item) => {
    return item.name.indexOf('.bin') === -1
  })
  const binContent = Base64.decode(binFile.data)
  const parsedBinContent = JSON.parse(binContent)
  const binInfo = JSON.parse(parsedBinContent[0])
  const type = binInfo.type
  // 更新图片时使用创建组件里的名字，不要重命名，将命名的逻辑都放在创建组件逻辑里
  const md5Name = getFileName(data.name, true) + '.bin'
  const url = `${resourcePath}${md5Name}`

  const onLoadAssetSuccess = async (asset) => {
    const image = {
      url: asset ? asset.url : '',
      src: asset ? _.get(asset, 'img.src') : '',
      uuid: asset ? asset.uuid : '',
    }
    if (image && image.uuid) {
      const getUuids = () => {
        if (nodes && nodes.length) {
          return nodes.map((item) => item.uuid)
        } else if (node) {
          return node.uuid
        }
        return ''
      }
      await store.dispatch('workspace/game/setImage', {
        resourceUuid: image.uuid,
        nodeUuid: getUuids(),
        resetImageAfterAdd: resetImageAfterAdd,
        resetAnotherLayout,
        addImageToConfig: addImageToConfig,
        record,
      })
    } else {
      throw new Error(i18n.t('workbench.utils.replaceResourcesError'))
    }

    // 更新图片后，需要更新 uuid2UrlConf 资源列表，保证资源加载正确
    assets.uuid2UrlConf = {
      ...assets.uuid2UrlConf,
      [binInfo.uuid]: image.url,
    }
    // 保存资源列表
    await saveGlobalUrlMap({
      projectKey: router.currentRoute.query.id,
      uuid2url: assets.uuid2UrlConf,
    })
  }

  // 检测类型是否正确
  if (type === AssetType.ASSET_ATLAS) {
    const isSaved = await saveFiles({ binContent, url, base64: imageFile.data })
    if (!isSaved) {
      throw new Error(i18n.t('workbench.utils.replaceResourcesError'))
    }
    if (isSetLibData) {
      libDataPool.setLibData(url, {
        name: getFileName(data.fileName || data.name, true),
      })
    }
    if (!isUpdateImage) return
    let nodeList = []
    if (nodes && nodes.length) {
      nodeList = [...nodes]
    } else if (node) {
      nodeList = [node]
    }
    const taskList = nodeList.map(async (node) => {
      const asset = await assets.load({
        uuid: node.uuid,
        url,
      })
      await onLoadAssetSuccess(asset)
    })
    await Promise.all(taskList)
    return true
  }
  throw new Error(i18n.t('workbench.utils.assetTypeError'))
}
